import { render, staticRenderFns } from "./AwarenessCard.vue?vue&type=template&id=5bc8b473&"
import script from "./AwarenessCard.vue?vue&type=script&lang=js&"
export * from "./AwarenessCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports